import IsBase64 from './base64-checker';

const requestUrl = window.location.hostname === 'localhost' ? '' : `https://${window.location.hostname}`;
const fileUrl = '/CkmbNelAbgtl4x-AIYSk8g1.json';

export default async function GetCryptoKey() {
    let cryptoKey = '';

    return await fetch(requestUrl + fileUrl)
        .then((response) => response.text())
        .then((data) => {
            for (let a = 1; a <= data.length / 5; a++) {
                cryptoKey += data.substr(5 * a - 1, 1);
            }
            const isValid = IsBase64(cryptoKey);
            if (!isValid) {
                return null;
            } else {
                return cryptoKey;
            }
        });
}
